import { Component, Input, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { INavInfo } from '../../model/models/layout/nav-info.interface';
import { RouteProvider } from '../../providers/route/route';
import { FormGroup } from '@angular/forms';
@Component({
  selector: 'rmt-select-actionsheet',
  templateUrl: 'rmt-select-actionsheet.html'
})
export class RmtSelectActionSheetComponent {
  @Input() placeholder: string;
  @Input() navInfo: INavInfo;
  @Input() navParams = {};
  @Input() listType: string;
  @Input() list = null;
  @Input() preItemText = '';
  @Input() label;
  @Input() floatingLabel: boolean = false;
  @Input() icon;
  @Input() addIconBadge: boolean = false;
  @Input() addFastestIconBadge: boolean = false;
  @Input() addLowestIconBadge: boolean = false;
  @Input() title;
 /**
   * The error message
  */
 @Input() errorMessage;
 @Input() defaultErrors: boolean = false;
 @Input() refFormControlError;
 @Input() hideError: boolean = false;
 @Input() showOnSubmit: boolean = false;
 @Input() refForm: FormGroup = null;
 @Input() submitAttempts: number = 0;
 @Input() isErrorHidden: boolean = true;
 //#endregion error  
  @Input() disable: boolean = false; // unfortunately we can't use the name disabled otherwise we could get reactive form warnings
  @ViewChild('input') input;
  @ViewChild('select') select;
  @Output() ionChange = new EventEmitter<any>();
  @ViewChild('selectPicker', { read: ElementRef }) selectPicker;

  selectItems: any = null;
  deliveryMethodTrans;
  paymentMethodTrans;
  floatContainers;
  selectedValue = "";
  constructor(private routeProvider: RouteProvider) {
  }

  showActionSheet() {
    if (!this.disable) {
      let navParams: any = Object.assign(this.navParams, {
        list: this.list, 
        listType: this.listType
      });

      if (!navParams.selectedItem && this.selectItems && this.selectItems.length > 0)
        navParams = { ...navParams, selectedItem: this.selectItems[0] };      
      if (!navParams.title && this.title)
        navParams = { ...navParams, title: this.title };
      if(this.deliveryMethodTrans)
        navParams = { ...navParams, deliveryMethod: this.deliveryMethodTrans };
      else if(this.paymentMethodTrans)
        navParams = { ...navParams, paymentMethod: this.paymentMethodTrans };

      this.routeProvider.openActionSheetNew(this.navInfo, navParams , (item) => {
        if (item) {
          this.selectItem(item);
        }
      });    
    }
    return false;
  }

  setValue(value, triggerEvents: boolean = true, list = null) {
    if (!list)
      list = this.list;

    if (value && list) {
      const item = list.find((item) => item.value === value);
      if (item)
        this.selectItem(item, triggerEvents);
    } else {
      this.selectItems = null;
      this.select.value = '';
      if (triggerEvents)
        this.ionChange.emit(null);
    }
  }

  selectItem(item, triggerEvents: boolean = true) {
    this.selectItems = [{  ...item }];
    if(this.listType === 'delivery') {
      this.deliveryMethodTrans = item.text;
    } else if(this.listType === 'payment') {
      this.paymentMethodTrans = item.value;
    }
    if(this.selectItems && this.selectItems[0]){
      this.selectedValue = this.selectItems[0].value;
    }
    if (triggerEvents)
      this.ionChange.emit(item);
  }

  getSelectedValue() {
    return this.selectedValue;
  }

  deselect() {
    this.selectItems = null;
    this.select.value = null;
  }

  anyFunc(event) {
    if (this.selectPicker && this.selectPicker.nativeElement) {
      const selectElemt = this.selectPicker.nativeElement;
      if (selectElemt && selectElemt.parentNode) {
        if (event) {
          selectElemt.parentNode.classList.add('active');
        } else {
          selectElemt.parentNode.classList.remove('active');
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-select-actionsheet/rmt-select-actionsheet.ts